import React from "react";
import ReactHookFormSwitch from "components/reactHookFormComponents/ReactHookFormSwitch";
import InputFieldControl from "components/base/InputFieldControl";
import { COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY } from "config/CustomEnums";
import { LimitsSplitLine } from "./CreateCampaignEarningPageConfig";
import { SectionTopTitle } from "components/base/CommonComponent";

export const CREATE_COUPON_CAMPAIGN_EARNING_PAGE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch, getValues } }) =>{
    const showCouponLimit = watch("showCouponLimit")
    return {
      displayNormalSectionComponents: [
        COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionContent.required_points_key,
        COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.show_limit_key,
        ...showCouponLimit ? [
          COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.display_overall_limit_key,
          COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.per_head_limit_key,
        ] : []
      ],
      displayLanguageSectionComponents: [],
    }
  },
  languageSections: [],
  normalSections: [
    {
      sectionKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionKey,
      sectionTitle: 'requirements',
      sectionContent: [
        {
          key: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionContent.required_points_key,
          component: InputFieldControl,
          componentProps: {
            name: 'requiredPoints',
            title: 'Required points',
            tips: 'You may input 0 if customers can acquire this coupon without points.',
            useDefaultFieldName: true,
            type: 'number',
            className: 'coupon-campaign-section-input width-160px',
          },
        },
      ]
    },
    {
      sectionKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionKey,
      sectionTitle: 'LIMITS',
      sectionContent: [
        {
          key: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.show_limit_key,
          component: ReactHookFormSwitch,
          componentProps: {
            valueFieldName: 'showCouponLimit',
          },
        },
        {
          key: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.display_overall_limit_key,
          complexComponent: () => (
            <>
              <LimitsSplitLine />
              <div style={{ marginTop: "30px" }}>
                <SectionTopTitle title={"Reward acquiring limit"} />
                <ReactHookFormSwitch
                  title='Display the overall limit in the campaign'
                  valueFieldName='displayOverLimit'
                />
              </div>
            </>
          ),
        },
        {
          key: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.per_head_limit_key,
          component: InputFieldControl,
          componentProps: {
            name: 'perHeadLimit',
            title:
              'Per head coupon acquiring limit during the campaign active period (optional)',
            useDefaultFieldName: true,
            type: 'number',
            unit: 'number of coupons',
            className: 'coupon-campaign-section-input width-160px',
          },
        },
    ]
    }
  ],
}